export default __webpack_public_path__ + "static/content-designer-16b63d4e0f5b39cc641c478290b9906a7a0a7530175af6437be0648197b875c1.png";